import type { HTMLAttributes, ReactNode } from "react";
import * as styles from "./EmptyState.style.ts";
import { H4 } from "src/components/HeadingV2/HeadingV2.tsx";
import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import Warning from "src/assets/warning.svg?react";

export type EmptyStateProps = {
  image?: ReactNode;
  title?: ReactNode;
  action?: ReactNode;
  description?: ReactNode;
  type: "warning";
} & HTMLAttributes<HTMLDivElement>;

export function EmptyState({
  image: imageProp,
  title,
  action,
  description,
  type,
  ...rest
}: EmptyStateProps) {
  const imageMap = {
    warning: <Warning />,
  };
  const image = imageMap[type] || imageProp;
  return (
    <div css={styles.root} {...rest}>
      {image && <div>{image}</div>}
      {(title || description) && (
        <div css={styles.content}>
          {title && <H4>{title}</H4>}
          {description && <TextV2 variant={"body1"}>{description}</TextV2>}
        </div>
      )}

      {action && <div>{action}</div>}
    </div>
  );
}
